
<ng-container *transloco="let t">
<form #addressHistoryForm="ngForm" novalidate id="addressHistoryForm" name="addressHistoryForm">
  <div class="fs-4 fw-bolder text-dark">{{currentAddressLabel}}</div>
  <div class="separator separator-dashed my-3"></div>
  <address-history2
    #currentAddressHistory
    [residencyAddress]="currentAddress"
    [fieldsToConfig]="currentAddressFieldsToConfig"
    [reo]="reoForCurrentAddress"
    [showMoveInDate]="true"
    (durationAtAddressChanged)="onDurationAtAddressChanged($event)"
    (ownershipStatusChanged)="onOwnershipStatusChanged($event)"
    (dateAcquiredChanged)="onCurrentAddressDateAcquiredChanged()"
    (addressChanged)="onAddressChanged($event)">
  </address-history2>
  @if (currentAddress.residencyBasis === 'Own') {
    <div>
      <reo-properties
        [mortgage]="mortgage"
        [reo]="reoForCurrentAddress"
        [fieldsToConfig]="reoFieldsToConfig"
        [hideDateAcquired]="true"
        #reoProperties>
      </reo-properties>
    </div>
  }
  @if (showInsufficientAddressHistoryWarning) {
    <div class="alert alert-warning d-flex align-items-center p-5 mb-10">
      <span class="svg-icon svg-icon-2hx svg-icon-warning me-4">
        <duotone-warning-circle-svg-icon></duotone-warning-circle-svg-icon>
      </span>
      <div class="d-flex flex-column">
        <h5 class="mb-1">{{ t('wizard.addressHistory.needAtLeast2Years') }}</h5>
        <span>{{ t('wizard.addressHistory.addPreviousAddresses') }}</span>
      </div>
    </div>
  }
  @if (previousAddresses.length > 0) {
    <div class="fs-4 fw-bolder text-dark">{{ t('wizard.addressHistory.previousAddresses') }}</div>
  }
  @if (previousAddresses.length > 0) {
    <div class="separator separator-dashed my-3"></div>
  }
  @for (previousAddress of previousAddresses; track previousAddress.residencyAddressId; let i = $index) {
    <div
      class="rounded border p-10 pb-0 mb-6 align-items-center flex-wrap ribbon ribbon-top ribbon-vertical"
      [ngClass]="{'border-danger' : previousAddressToDelete === previousAddress}">
      <div class="ribbon-label bg-white">
        @if (previousAddressToDelete !== previousAddress) {
          <i class="bi bi-trash fs-2 text-warning"
            (click)="onPreviousAddressDeleteClicked(previousAddress)"></i>
        }
        @if (previousAddressToDelete === previousAddress) {
          <i class="bi bi-x fs-2 text-danger"
            (click)="onPreviousAddressDeleteCancelClicked(previousAddress)"></i>
        }
        @if (previousAddressToDelete === previousAddress) {
          <i class="bi bi-check fs-2 text-success"
            style="padding-right: 4px;" (click)="onPreviousAddressDeleteConfirmClicked(previousAddress)"></i>
        }
      </div>
      <address-history2 #previousAddressHistory (durationAtAddressChanged)="onDurationAtAddressChanged($event)"
        [residencyAddress]="previousAddress" [fieldsToConfig]="fieldConfig">
      </address-history2>
    </div>
  }
</form>
</ng-container>
